<template>
    <div id="selelctitem"  ref="sel" :class="{'indexclase':pageselect_show}">
        <span class="select_title" @click="showbox">
            {{ bindName }}<i v-if="bindId.length<1">{{ placeholder }}</i> 
            <img src="~@/assets/xia.png">
        </span>
        <div class="option_box"   v-if="pageselect_show" >
            <div class="option_shou">
                <input @input="pageShouChang" v-model="page_shou_str" placeholder="请输入关键词"/>
                <img src="~@/assets/serch.png"/>
            </div>
            <ul class="options">
                <li v-if="bindId.length<1&&placeholder.length>0&&is_show_pla" >{{ placeholder }}</li>
                <li v-for="item in opserchList" :key="item.id" :class="{'selected':item.id==bindId}" @click="selectpage(item.id)">{{item.name}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name:"Select",
        data(){
            return{
                bindId:"",
                bindName:"",
                pageselect_show:false,
                page_shou_str:"",
                opserchList:[],
                is_show_pla:true
                
            }
        },
        props:{
            modelValue:{
                type: String,
                default:""
            },
            optionList:{
                type:Array,
                required:true
            },
            placeholder:{
                type:String,
                default:""
            }

        },
        watch:{
            opserchList(newVal) {
                   this.showname()
                    
            }
            
        }
        ,
        async mounted(){
           this.opserchList=this.optionList
           this.bindId=this.modelValue
        },
        methods:{
            hideList(e){
                let s1=this.$refs.sel
                
                if((s1!==null||s1!=undefined)&&!s1.contains(e.target)){
                    this.pageselect_show=false
                    this.page_shou_str=""
                    this.opserchList=this.optionList
                    this.is_show_pla=true
                    window.removeEventListener('click', this.hideList)
                    
                }
               
            },
            showname(){
                if(this.opserchList!=undefined){
                        for (let i = 0; i < this.opserchList.length; i++) {
                            if(this.opserchList[i].id==this.bindId){
                                this.bindName=this.opserchList[i].name
                                return
                            }
                            
                        }
                }
                
            },
            showbox(){
                if(!this.pageselect_show){
                    this.indexnum=9
                    window.addEventListener('click', this.hideList)
                }else{
                    this.indexnum=0
                }
                this.page_shou_str=""
                this.opserchList=this.optionList
                this.is_show_pla=true
                this.pageselect_show=!this.pageselect_show
            },
            selectpage(id){
                this.bindId=id
                for (let i = 0; i < this.opserchList.length; i++) {
                    if(this.opserchList[i].id==this.bindId){
                        this.bindName=this.opserchList[i].name
                        break
                    }
                    
                }
                this.page_shou_str=""
                this.opserchList=this.optionList
                this.is_show_pla=true
                window.removeEventListener('click', this.hideList)
                this.$emit('update:modelValue', this.bindId)
                this.pageselect_show=false

            },
            pageShouChang(){
                if(this.optionList==null||this.optionList==undefined){
                    return
                }
                if(this.page_shou_str.length<1){
                    this.is_show_pla=true
                    this.opserchList=this.optionList
                    
                }else{
                    this.is_show_pla=false
                    this.opserchList=[]
                    for (let i = 0; i < this.optionList.length; i++) {
                        if(this.optionList[i].name.includes(this.page_shou_str)){
                            this.opserchList.push(this.optionList[i])
                        }
                        
                    }
                   

                }
            }
        }
    }
</script>
<style scoped>
#selelctitem{
    width: 100%;
    height: auto;
    float: left;
    position: relative;
    
}
#selelctitem.indexclase{
    z-index: 9;
}
#selelctitem .select_title{
    width: 100%;
    height: 50px;
    float: left;
    border: 1px solid #ccc;
    border-radius: 5px;
    color: #838080;
    line-height: 50px;
    padding-left: 10px;
    position: relative;
}
#selelctitem .select_title i{
    width: 100%;
    height: 50px;
    float: left;
    font-style: normal;
    
}
#selelctitem .select_title img{
    width: 20px;
    height: 20px;
    position: absolute;
    right: 5px;
    top: 15px;
}
#selelctitem .option_box{
    width: 100%;
    height: auto;
    float: left;
    padding: 10px 0;
    background-color: #fff;
    border:1px solid #ccc;
}
#selelctitem .option_box .option_shou{
    width: 100%;
    height: 40px;
    float: left;
    position: relative;
    padding: 0 10px;
    
}
#selelctitem .option_box .option_shou input{
    line-height: 40px;
    height: 40px;
    width: 100%;
    float: left;
    font-size: 14px;
    padding-right: 25px;
    border-radius: 5px;
    border: 1px solid #ccc;
    outline: none;
}
#selelctitem .option_box .option_shou img{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 15px;
}
#selelctitem .option_box .options{
    width: 100%;
    height: 260px;
    float: left;
    padding:5px 0px;
    overflow: hidden;
    overflow-y:auto;
    margin: 0;
    margin-top: 5px;
}
#selelctitem .option_box .options li{
    width: 100%;
    height: 40px;
    float: left;
    list-style: none;
    line-height: 40px;
    color: #4a4a4a;
    padding: 0 10px;
}
#selelctitem .option_box .options li.selected{
    background-color: #3142d2;
    color: #fff;
}
</style>